/// <amd-module name="Wit/Filter/AreaPathHelper" />
export function getAreaPathLeafNode(path: string): string {
    const nodes = path ? path.split("\\") : [""];
    return nodes[nodes.length - 1];
}

export function getAreaPathsMatchingLeaf(paths: string[], leafNode: string): string[] {
    return paths.filter(path => path.endsWith(`\\${leafNode}`));
}
